import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useIntl } from 'react-intl';

import {
  getMatchId,
  getMatchHomeConceded,
  getMatchAwayConceded,
  getMatchSportId,
} from 'reducers';
import { sport } from 'constants/enum';
import NumberStatSlide from 'newDesign/modules/live/components/footer/footerBottom/numberSlideContainers/NumberStatSlide';

const mapStateToProps = state => ({
  homeStat: getMatchHomeConceded(state, getMatchId(state)),
  awayStat: getMatchAwayConceded(state, getMatchId(state)),
  sportId: getMatchSportId(state, getMatchId(state)),
});

const Conceded = ({
  homeStat, awayStat, sportId,
}) => {
  const intl = useIntl();
  const homeRounded = Math.round(homeStat * 10) / 10;
  const awayRounded = Math.round(awayStat * 10) / 10;

  const translationKey = [sport.basketball, sport.basketball3x3].includes(sportId) ? 't_footer_points_conceded' : 't_footer_goals_conceded';
  const translatedPhrase = intl.formatMessage({ id: translationKey });

  return (
    <NumberStatSlide
      statText={intl.formatMessage({ id: 't_footer_score_action_prefix' }, { action: translatedPhrase })}
      homeStat={homeRounded}
      awayStat={awayRounded}
      higherIsBetter={false}
    />
  );
};

Conceded.propTypes = {
  homeStat: PropTypes.number,
  awayStat: PropTypes.number,
  sportId: PropTypes.number.isRequired,
};

Conceded.defaultProps = {
  homeStat: null,
  awayStat: null,
};

export default connect(mapStateToProps)(Conceded);
